gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(TextPlugin)
gsap.registerPlugin(ScrollToPlugin)

// relies on passed array from template-approach.php
const serviceArray = jsServiceArray
// declare variables
const arrayLength = serviceArray.length
const motifSegment = 360 / arrayLength
const motifRotation = 360 - motifSegment
let windowWidth = window.innerWidth
let windowHeight = window.innerHeight
let approachTL
let currentIndex = 0
let animating

window.addEventListener("resize", (event) => {
    windowWidth = window.innerWidth
    windowHeight = window.innerHeight
})

const approachScrollTrigger = () => {
    const approachInitTL = gsap.timeline({
        scrollTrigger: {
            trigger: ".services-section#graphic-view",
            start: "center bottom",
            scrub: false,
        },
        defaults: { ease: "linear", duration: 3 },
    })

    approachInitTL.from(".services-section#graphic-view .content", {
        opacity: 0,
        duration: 1,
    })

    approachTL = gsap.timeline({
        scrollTrigger: {
            trigger: ".services-section#graphic-view",
            start: "center center",
            scrub: true,
            pin: true,
            end: "+=800%",
            snap: {
                snapTo: "labelsDirectional",
                duration: { min: 0.2, max: 2.5 },
                delay: 0.2,
                ease: "power1.inOut",
            },
        },
        defaults: { ease: "linear", duration: 3 },
    })

    for (let i = 0; i < arrayLength; i++) {
        approachTL.to(
            ".services-section#graphic-view .circle-motif-wrapper .circle-motif svg",
            {
                rotate: (motifRotation / arrayLength) * (i + 1),
            }
        )
        if (i != 0) {
            // change motif
            // hide previous content
            approachTL
                .to(
                    ".services-section#graphic-view .content .service #title",
                    {
                        y: -20,
                        opacity: 0,
                        duration: 0.15,
                        ease: "power3.in",
                    },
                    "<+1"
                )
                .to(
                    ".services-section#graphic-view .content .service p#description",
                    {
                        y: -20,
                        opacity: 0,
                        duration: 0.15,
                        ease: "power3.in",
                    },
                    "<+0.1"
                )
                .to(
                    ".services-section#graphic-view .content .service #service-details-wrapper p",
                    {
                        y: -20,
                        opacity: 0,
                        duration: 0.15,
                        ease: "power3.in",
                    },
                    "<+0.1"
                )
                .to(
                    ".services-section#graphic-view .content .service #service-details-wrapper ul#service-details li",
                    {
                        opacity: 0,
                        duration: 0.1,
                        ease: "power3.in",
                    },
                    "<+0.1"
                )
                .to(
                    ".services-section#graphic-view .accent-line",
                    {
                        scaleX: 0,
                        duration: 0.1,
                        ease: "power3.in",
                    },
                    "<+0.1"
                )

                // change content to current service
                .set(
                    ".services-section#graphic-view .content .service #title",
                    {
                        text: serviceArray[i].title,
                    },
                    ">"
                )
                .set(
                    ".services-section#graphic-view .content .service p#description",
                    {
                        text: serviceArray[i].description,
                    },
                    ">"
                )

                // change accent colour
                .set(
                    ".services-section#graphic-view .content .accent-line",
                    {
                        backgroundColor: serviceArray[i].color,
                    },
                    "<"
                )

                // show current content
                .to(
                    ".services-section#graphic-view .content .service #title",
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.25,
                        ease: "power3.out",
                    },
                    ">+0.15"
                )
                .to(
                    ".services-section#graphic-view .content .service p#description",
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.25,
                        ease: "power3.out",
                    },
                    "<+0.1"
                )
            // additional services listing details
            for (let x = 0; x < serviceArray[i].details.length; x++) {
                approachTL.set(
                    `.services-section#graphic-view .content .service #service-details li:nth-child(${
                        x + 1
                    })`,
                    {
                        text: serviceArray[i].details[x],
                    },
                    "<"
                )
            }

            approachTL
                .to(
                    ".services-section#graphic-view .content .service #service-details-wrapper p",
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.25,
                        ease: "power3.out",
                    },
                    "<+0.1"
                )
                .to(
                    ".services-section#graphic-view .content .service ul#service-details li",
                    {
                        opacity: 1,
                        duration: 0.25,
                        stagger: 0.05,
                        ease: "power3.out",
                    },
                    "<+0.1"
                )
                .to(
                    ".services-section#graphic-view .accent-line",
                    {
                        scaleX: 1,
                        duration: 0.25,
                        ease: "power3.out",
                    },
                    "<+0.1"
                )
        }
        approachTL.addLabel(`service0${i + 1}`)
    }
}

const approachListView = () => {
    // button
    const button = document.querySelector("#all-services")
    const graphicView = document.querySelector(".services-section#graphic-view")
    const pinSection = graphicView.parentNode
    const listView = document.querySelector(".services-section#list-view")

    const graphicViewExitTL = gsap.timeline({
        defaults: { ease: "linear", duration: 3 },
        onStart: () => {
            approachTL.kill()
            listView.classList.remove("inactive")
        },
        onComplete: () => {
            pinSection.remove()
            gsap.to(window, {
                duration: 0,
                scrollTo: ".services-section#list-view",
                ease: "expo.inOut",
                onComplete: () => {
                    listViewEnterTL.play()
                },
            })
        },
    })

    graphicViewExitTL
        .to(".services-section#graphic-view .accent-line", {
            scaleX: 0,
            duration: 0.25,
            ease: "power3.in",
        })
        .to(
            ".services-section#graphic-view .content .service #title",
            {
                y: -20,
                opacity: 0,
                duration: 0.15,
                ease: "power3.in",
            },
            "<+0.25"
        )
        .to(
            ".services-section#graphic-view .content .service p#description",
            {
                y: -20,
                opacity: 0,
                duration: 0.15,
                ease: "power3.in",
            },
            "<+0.1"
        )
        .to(
            ".services-section#graphic-view .content .service #service-details-wrapper p",
            {
                y: -20,
                opacity: 0,
                duration: 0.15,
                ease: "power3.in",
            },
            "<+0.1"
        )
        .to(
            ".services-section#graphic-view .circle-motif-wrapper .circle-motif p",
            {
                opacity: 0,
                duration: 0.25,
                ease: "power3.in",
            },
            "<"
        )
        .to(
            ".services-section#graphic-view .circle-motif-wrapper .circle-motif svg",
            {
                x: "100vw",
                duration: 0.5,
                ease: "expo.in",
            },
            "<+0.1"
        )
        .to(
            ".services-section#graphic-view .content .service #service-details-wrapper ul#service-details li",
            {
                opacity: 0,
                duration: 0.15,
                ease: "power3.in",
            },
            "<"
        )
        .to(
            ".services-section#graphic-view .content button",
            {
                opacity: 0,
                duration: 0.15,
                ease: "power3.in",
            },
            "<+0.1"
        )

    const listViewEnterTL = gsap.timeline({
        delay: 0.35,
        defaults: { ease: "power3.out", duration: 3 },
    })

    listViewEnterTL
        .from(".services-section#list-view h2", {
            y: -20,
            opacity: 0,
            duration: 0.25,
        })
        .from(
            ".services-section#list-view .service",
            {
                opacity: 0,
                duration: 0.72,
                stagger: 0.1,
                ease: "linear",
            },
            "<+0.1"
        )
        .from(
            ".services-section#list-view .service .accent-line",
            {
                scaleX: 0,
                duration: 0.5,
                stagger: 0.25,
            },
            "<"
        )

    graphicViewExitTL.pause()
    listViewEnterTL.pause()

    button.addEventListener("click", () => {
        graphicViewExitTL.play()
    })

    const mobileList = () => {
        if (windowWidth < 900) {
            approachTL.kill()
            pinSection.remove()
            listView.classList.remove("inactive")
            listViewEnterTL.play()
        }
    }

    mobileList()
    window.addEventListener("resize", (event) => {
        mobileList()
    })
}

// Skip Section Button
// Check if it's a touch device
const isTouchDevice = "ontouchstart" in window
const createCursorFollower = () => {
    const $el = document.querySelector(".cursor-follower")

    const followerWidth = $el.getBoundingClientRect().width
    const followerHeight = $el.getBoundingClientRect().height

    window.addEventListener("mousemove", (e) => {
        const { target, x, y } = e
        // Check if target is inside `#skip-services`
        // const isTargetLinkOrBtn = target?.closest('a') || target?.closest('button');
        const isTargetSkip = target?.closest("#skip-services")
        // GSAP config
        gsap.to($el, {
            x: x - followerWidth / 2,
            y: y - followerHeight / 2,
            duration: 1,
            ease: "expo",
            opacity: isTargetSkip ? 1 : 0,
            transform: `scale(${isTargetSkip ? 1 : 0})`,
            // duration: 0.7,
            // ease: "power4",
            // transform: `scale(${isTargetLinkOrBtn ? 3 : 1})`,
        })
    })

    // function to hide cursor
    document.addEventListener("mouseleave", (e) => {
        gsap.to($el, {
            duration: 0.7,
            opacity: 0,
        })
    })

    // skip section
    const skipButton = document.querySelector("#skip-services")
    skipButton.addEventListener("click", () => {
        approachTL.pause()
        approachTL.seek(approachTL.endTime())

        gsap.to(window, {
            duration: 0.7,
            scrollTo: ".section#steps",
            ease: "expo.inOut",
            onStart: () => {
                gsap.to($el, {
                    duration: 1,
                    ease: "expo",
                    opacity: 0,
                })
            },
        })
    })
}

// Only invoke the function if isn't a touch device
// if (!isTouchDevice) {
//     createCursorFollower()
// }

// execute approach functions
approachScrollTrigger()
approachListView()

// skip section
const skipButton = document.querySelector("#skip-services")
skipButton.addEventListener("click", () => {
    approachTL.pause()
    approachTL.seek(approachTL.endTime())

    gsap.to(window, {
        duration: 0.7,
        scrollTo: ".section#steps",
        ease: "expo.inOut"
    })
})
